module.exports = __webpack_public_path__ + "static/media/hyu_erica_background.1e546314.jpg";